import { polyfill } from 'es6-promise'; polyfill();

import Vue from 'vue'
import App from './App'
import { createRouter } from './router'
import axios from 'axios';
import state from './state';
import noty from './services/noty.service';
import faAll from '@fortawesome/fontawesome-free/js/all.min';

import "flatpickr/dist/flatpickr.js";
import "flatpickr/dist/flatpickr.css";

import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

import vuelidate from 'vuelidate';
Vue.use(vuelidate);

import VeeValidate from "vee-validate";
Vue.use(VeeValidate, { events: "", inject: false });

import i18nPlugin from './plugins/i18n.plugin';

const debug = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = debug;

Vue.use(i18nPlugin, { state });

Vue.http = axios.create();

const router = createRouter();

Vue.http.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      state.admin.unset();
      router.push({ name: 'login' });
      noty.warning('Unauthorized');
    } else {
      noty.error(`Http status code ${error.response.status}`);
    }
    return Promise.reject(error);
  });

/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js